import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=0e793fdc&"
import script from "../model/title.js?vue&type=script&lang=js&"
export * from "../model/title.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports